import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_CHECK_FORCE_UNCLAIM_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { checkForceUnclaimFailure, checkForceUnclaimSuccess } from '../actions';
import { forwardTo } from './EditorSaga';
import { DASHBOARD_ROUTE } from '../../../../constants/RouteNameConstants';

const checkForceUnclaimAPI = (action) => postApiRequest(PROOFREADER_CHECK_FORCE_UNCLAIM_API_URL, action);

function* handleCheckForceUnclaim(action) {
  try {
    const response = yield call(checkForceUnclaimAPI, action.payload);
    const parsedResponse = response.data.value;
    if (parsedResponse === 'null') {
      yield put(checkForceUnclaimSuccess(response));
    } else {
      yield call(forwardTo, DASHBOARD_ROUTE);
    }
  } catch (error) {
    yield put(checkForceUnclaimFailure(error));
  }
}

export function* watchCheckForceUnclaim() {
  yield takeLatest(types.CHECK_FORCE_UNCLAIM_REQUEST, handleCheckForceUnclaim);
}
